import { NavTabItem, NavTabs } from '@app/components/NavTabs'
import MaintenancePage from '@app/routes/Maintenance/MaintenancePage'
import { ICurrentUserState } from '@app/store/modules/account'
import { bindFunctions } from '@app/utils/class'
import { humanize } from '@app/utils/formatting'
import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { Link, Route, RouteComponentProps, Switch } from 'react-router-dom'
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap'
import { actionCreators, ITeamViewState } from '../modules/teamView'
import TeamAccess from './TeamAccess'
import TeamMembers from './TeamMembers'

interface IComponentRouterProps {
  id: string
}

type IComponentProps = ITeamViewState &
  ICurrentUserState &
  RouteComponentProps<IComponentRouterProps> &
  typeof actionCreators

export default class GuestViewPage extends React.PureComponent<
  IComponentProps
> {
  private teamId: string

  constructor(props: IComponentProps) {
    super(props)

    bindFunctions(this)
  }

  public componentDidMount() {
    const { id } = this.props.match.params
    this.teamId = id
    this.props.loadTeam(id)
  }

  public componentDidUpdate(
    prevProps: IComponentProps,
    prevState: any,
    snapshot: any,
  ) {
    const { id } = this.props.match.params
    if (prevProps.item && prevProps.item.id !== id) {
      this.teamId = id
      this.props.loadTeam(id)
    }
  }

  public render() {
    if (!this.props.item || !this.props.user) {
      return <div />
    }

    return (
      <DocumentTitle title={this.props.item.name}>
        <Container className='mt-3'>
          <Card className='d-flex flex-column mt-2'>
            <CardHeader className='bg-secondary text-white'>
              {this._renderCardHeader()}
            </CardHeader>
            <CardBody>{this._renderCardBody()}</CardBody>
          </Card>
          {this._renderTabs()}
          <Switch>
            <Route
              exact
              path={this.props.match.path}
              render={() => <TeamMembers {...this.props} />}
            />
            <Route
              exact
              path={`${this.props.match.path}/access`}
              render={() => <TeamAccess {...this.props} />}
            />
            <Route component={MaintenancePage} />
          </Switch>
        </Container>
      </DocumentTitle>
    )
  }

  private _renderAccess() {
    if (!this.props.item) {
      return null
    }

    if (
      !this.props.item.allowedAccessTo ||
      this.props.item.allowedAccessTo.size === 0
    ) {
      return 'No specific access rules applied'
    }

    const access = this.props.item.allowedAccessTo.map((item: any) => {
      return (
        <div
          key={item}
          style={{ borderBottom: '1px solid #ddd' }}
          className='d-flex flex-row flex-wrap justify-content-between mt-2'
        >
          <div>
            <strong>{item.name}</strong>
          </div>
          <div>{humanize(item.value)}</div>
        </div>
      )
    })

    return <div>{access}</div>
  }

  private _renderCardBody() {
    return (
      <div className='d-flex flex-row flex-wrap'>
        <div className='d-flex flex-column ml-3 align-self-center'>
          <div style={{ fontWeight: 'bold' }}>{this.props.item.name}</div>
          <div>{this.props.item.description}</div>
        </div>
      </div>
    )
  }

  private _renderCardHeader() {
    if (!this.props.user) {
      return null
    }

    const connectionHeaderIcon: [IconPrefix, IconName] = ['fal', 'user']

    return (
      <div className='d-flex flex-row'>
        <span>
          <FontAwesomeIcon
            className='primary-color'
            icon={connectionHeaderIcon}
            fixedWidth
          />
          Team
        </span>
        <div className='ml-auto'>
          {this._canEdit() && this._canDelete() && (
            <UncontrolledDropdown style={{ display: 'inline' }}>
              <DropdownToggle tag='a' className='px-1 text-center'>
                <FontAwesomeIcon icon={['fal', 'chevron-down']} fixedWidth />
              </DropdownToggle>
              {this._renderDropdown()}
            </UncontrolledDropdown>
          )}
        </div>
      </div>
    )
  }

  private _renderDropdown() {
    const menuItems = []

    if (this._canEdit()) {
      menuItems.push(
        <Link key='edit' to={`/admin/team/${this.teamId}/edit`}>
          <DropdownItem>Edit</DropdownItem>
        </Link>,
      )
    }

    if (this._canDelete()) {
      menuItems.push(
        <Link key='delete' to={`/admin/team/${this.teamId}`}>
          <DropdownItem>Delete</DropdownItem>
        </Link>,
      )
    }

    return <DropdownMenu>{menuItems}</DropdownMenu>
  }

  private _canDelete() {
    return true
  }

  private _canEdit() {
    return true
  }

  private _renderTabs() {
    return (
      <div className='mb-3 mt-3'>
        <NavTabs>
          <NavTabItem
            exact
            iconName='users'
            label='Members'
            to={this.props.match.url}
          />
          <NavTabItem
            iconName='lock'
            label='Access'
            to={`${this.props.match.url}/access`}
          />
        </NavTabs>
      </div>
    )
  }
}
